import React, { useState, useEffect } from "react";
import "./styles/plan.scss";
import { useAuth } from "../../pages/login/AuthProvider";
import { useNavigate, useLocation  } from "react-router-dom";
import Swal from 'sweetalert2';
import axios from "axios";
import { backend } from '../../components/apipath';
import { usePayment } from "../../components/PaymentContext";

function Plan() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const parentId = queryParams.get("parent_id") || 1;
    const { step, setStep } = usePayment();
    const { authorized } = useAuth();
    const navigate = useNavigate();
    const [productData, setProductData] = useState([]);
    const [selectedCardId, setSelectedCardId] = useState(1);

    useEffect(() => {
        localStorage.removeItem("selectedPlan");
    }, []);
    const handleSelectPlan = (productId) => {
        setSelectedCardId(productId); 
    };

    useEffect(() => {
        if (step < 1) {
            navigate("/registration/");
        }
    }, [step]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${backend}product/productData?parent_id=${parentId}`);
                const data = response.data;
    
                let initializedData;
                if (parentId === "1") {
                    initializedData = data.map((product, index) => {
                        let position = "";
                        if (index === 3) position = "far-left";
                        else if (index === 4) position = "left";
                        else if (index === 0) position = "center";
                        else if (index === 1) position = "right";
                        else if (index === 2) position = "far-right";
                        return { ...product, position };
                    });
                } else {
                    initializedData = data.map((product) => ({
                        ...product,
                        position: "simple", 
                    }));
                }
    
                setProductData(initializedData);
            } catch (error) {
                console.error("Error:", error);
            }
        };
    
        fetchData();
    }, [parentId]);


    const handleClick = (clickedId) => {
        setSelectedCardId(clickedId);
    
        const clickedIndex = productData.findIndex((product) => product.product_id === clickedId);
        const totalCards = productData.length;
    
        // 更新卡片的位置
        const updatedCards = productData.map((product, index) => {
            const distance = (index - clickedIndex + totalCards) % totalCards;
            let position = "";
    
            switch (distance) {
                case 0:
                    position = "center";
                    break;
                case 1:
                    position = "right";
                    break;
                case 2:
                    position = "far-right";
                    break;
                case totalCards - 1:
                    position = "left";
                    break;
                case totalCards - 2:
                    position = "far-left";
                    break;
                default:
                    position = "";
            }
    
            return { ...product, position };
        });
        // console.log("Clicked ID:", clickedId);
        // console.log("Updated Cards:", updatedCards);
        setProductData(updatedCards);
    };

    const handleNextStepClick = () => {
        if (!authorized) {
            Swal.fire({
                icon: "warning",
                color: "#224040",
                text: "尚未登入會員",
            });
            navigate("../member/memberlogin");
        } else {
            if (selectedCardId) {
                localStorage.setItem("selectedPlan", selectedCardId);
                localStorage.setItem("selectedParentId", parentId);
                setStep(1);
                navigate(`../registration/payinfo?product_id=${selectedCardId}&parent_id=${parentId}`);
            } else {
                Swal.fire({
                    icon: "warning",
                    color: "#224040",
                    text: "請選擇一個方案",
                });
            }
        }
    };
    

    const handleNextStep = () => {
        if (!authorized) {
            Swal.fire({
                icon: "warning",
                color: "#224040",
                text: "尚未登入會員",
            });
            navigate("../member/memberlogin");
        } else {
            if (selectedCardId) {
                localStorage.setItem('selectedPlan', selectedCardId);
                setStep(1);
                navigate(`../registration/payinfo`);
            } else {    
                Swal.fire({
                    icon: "warning",
                    color: "#224040",
                    text: "請選擇一個方案",
                });
            }
        }
    };

    return (
        <>
            <div className="wplan">
                <div className="beckertitlename m-5">請確認購買方案</div>
                
                    {parentId === "1" ? (
                    <div className="container-fluid">
                        <div className="carousel-container">
                            {productData.map((product) => (
                                <div key={product.product_id} className={`carousel-card ${product.position}`} onClick={() => handleClick(product.product_id)}>
                                    <div className="card pdbox planh">
                                        <h5>{product.name}</h5>
                                        <div className="card-body" dangerouslySetInnerHTML={{ __html: product.content }}></div>
                                        <div className="ugbk">
                                            <h6>使用效期</h6>
                                            <span>{product.exp}個月</span>
                                        </div>
                                        <div className="ugbk">
                                            <h6>適用客群</h6>
                                            <span>{product.applicable}</span>
                                        </div>
                                        <div className="cash">{product.price}</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="nextstep text-center">
                            <button className="btn btn-primary mb-3" onClick={handleNextStepClick}>下一步</button>
                        </div>
                    </div>
                    ) : (
                        <div className="container mb100">
                            <div className="row justify-content-center">
                            {productData.map((product) => (
                                <div key={product.product_id} className="col-md-6">
                                    <div 
                                        className={`card pdbox w-75 h-100 mb-5 ${selectedCardId === product.product_id ? 'selected' : 'dimmed'}`} 
                                        onClick={() => handleSelectPlan(product.product_id)}
                                    >
                                        <h5>{product.name}</h5>
                                        <div className="card-body" dangerouslySetInnerHTML={{ __html: product.content }}></div>
                                        <div className="ugbk">
                                            <h6>使用效期</h6>
                                            <span>{product.exp}個月</span>
                                        </div>
                                        <div className="ugbk">
                                            <h6>適用客群</h6>
                                            <span>{product.applicable}</span>
                                        </div>
                                        <div className="cash">{product.price}</div>
                                    </div>
                                </div>
                            ))}
                            </div>
                            <div className="nextstep text-center">
                                <button className="btn btn-primary mb-3" onClick={handleNextStep}>下一步</button>
                            </div>
                        </div>
                        
                    )}   
            </div>
            {/* <div className="mplan">
                <div className="beckertitlename mt100">請確認購買方案</div>
                <div className="container">
                    <div className="card pdbox w-75 h-100 mb-5">
                        <h5>專業方案</h5>
                        <div className="card-body">
                        <ul className="align-items-stretch">
                            <li>CPA Exam Review 軟體與四本教科書 (含 Flashcards)</li>
                            <li>英文線上解題 (Academic Support)</li>
                            <li className="text-danger">考程顧問諮詢輔導</li>
                            <li className="text-danger">CPA Final Review 軟體</li>
                            <li className="text-danger">All In One 國際就業力課程</li>
                            <li className="text-danger">完整四科中文課程</li>
                            <li className="text-danger">線上導讀與解題影片</li>
                            <li className="text-danger">中文線上解題服務</li>
                            <li className="text-danger">CPE Select 一年份執照進修課程</li>
                        </ul>
                        </div>
                        <div className="ugbk">
                            <h6>使用效期</h6>
                            <span>24個月</span>
                        </div>
                        <div className="ugbk">
                            <h6>適用客群</h6>
                            <span>帶職、在學備考者並使用中文課程與線上解題服務</span><br/>
                        </div>
                        <div className="cash">120,000</div>
                        
                        <Link to="../registration/payinfo" target="_blank" className="bt_prd">»報名與購買</Link>
                    </div>
                    <div className="card pdbox w-75 h-100 mb-5">
                        <h5>全修方案</h5>
                        <div className="card-body">
                        <ul className="align-items-stretch">
                            <li>CPA Exam Review 軟體與四本教科書 (含 Flashcards)</li>
                            <li>英文線上解題 (Academic Support)</li>
                            <li className="text-danger">考程顧問諮詢輔導</li>
                            <li className="text-danger">CPA Final Review 軟體</li>
                            <li className="text-danger">All In One 國際就業力課程</li>
                            <li className="text-danger">完整四科中文課程</li>
                            <li className="text-danger">線上導讀與解題影片</li>
                            <li className="text-danger">中文線上解題服務</li>
                        </ul>
                        </div>
                        <div className="ugbk">
                            <h6>使用效期</h6>
                            <span>24個月</span>
                        </div>
                        <div className="ugbk">
                            <h6>適用客群</h6>
                            <span>留學生、僅須重點中文課程者</span><br/>
                        </div>
                        <div className="cash">80,000</div>
                        
                        <Link to="../registration/payinfo" target="_blank" className="bt_prd">»報名與購買</Link>
                    </div>
                    <div className="card pdbox w-75 h-100 mb-5">
                        <h5>選修方案</h5>
                        <div className="card-body">
                            <ul className="align-items-stretch">
                                <li>CPA Exam Review 軟體與四本教科書 (含 Flashcards)</li>
                                <li>英文線上解題 (Academic Support)</li>
                                <li className="text-danger">三次考程顧問諮詢輔導</li>
                                <li className="text-danger">任選6堂中文課程</li>
                                <li className="text-danger">CPA Final Review 軟體</li>
                                <li className="text-danger">All In One 國際就業力課程</li>
                            </ul>
                        </div>
                        <div className="ugbk">
                            <h6>使用效期</h6>
                            <span>24個月</span>
                        </div>
                        <div className="ugbk">
                            <h6>適用客群</h6>
                            <span>留學生</span><br/>
                        </div>
                        <div className="cash">46,000</div>
                        
                        <Link to="../registration/payinfo" target="_blank" className="bt_prd">»報名與購買</Link>
                    </div>
                    <div className="card pdbox w-75 h-100 mb-5">
                        <h5>自修方案</h5>
                        <div className="card-body">
                            <ul className="align-items-stretch">
                                <li>CPA Exam Review 軟體與四本教科書 (含 Flashcards)</li>
                                <li>英文線上解題 (Academic Support)</li>
                            </ul>
                        </div>
                        <div className="ugbk">
                            <h6>使用效期</h6>
                            <span>24個月</span>
                        </div>
                        <div className="ugbk">
                            <h6>適用客群</h6>
                            <span>帶職、在學備考者</span><br/>
                        </div>
                        <div className="cash">120,000</div>
                        
                        <Link to="../registration/payinfo" target="_blank" className="bt_prd">»報名與購買</Link>
                    </div>
                    <div className="card pdbox w-75 h-100 mb-5">
                        <h5>單科雙語</h5>
                        <div className="card-body">
                            <ul className="align-items-stretch">
                                <li>CPA Exam Review 軟體與四本教科書 (含 Flashcards)</li>
                                <li>英文線上解題 (Academic Support)</li>
                                <li>單科中文課程</li>
                            </ul>
                        </div>
                        <div className="ugbk">
                            <h6>使用效期</h6>
                            <span>24個月</span>
                        </div>
                        <div className="ugbk">
                            <h6>適用客群</h6>
                            <span>留學生、僅須重點中文課程者</span><br/>
                        </div>
                        <div className="cash">80,000</div>
                        
                        <Link to="../registration/payinfo" target="_blank" className="bt_prd">»報名與購買</Link>
                    </div>
                </div>
            </div>     */}
        </>
    );
}

export default Plan;